import {
	Directive,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output
}                               from '@angular/core';
import { AuthorizationService } from '@app/core/services/authorization/authorization.service';
import {
	ApplicationScopeTypes,
	ScopeActionEnum,
	ScopePermissionCheckEnum
}                               from '@models/scope.enums';

@Directive( {
	selector: '[appAccessFlowCheck]'
} )
export class AccessFlowCheckDirective implements OnInit {
	private _permissionCheck: ScopePermissionCheckEnum = ScopePermissionCheckEnum.AND;

	/**
	 * Scopes passed in here are checked for whether there is permission
	 * for all scopes (AND) or for at least one scope (OR). Default is AND.
	 * (Only relevant if a list of scopes is passed in.)
	 */
	@Input() set permissionCheck( permissionCheck: ScopePermissionCheckEnum ) {
		this._permissionCheck = permissionCheck ?? this._permissionCheck;
	}

	get permissionCheck(): ScopePermissionCheckEnum {
		return this._permissionCheck;
	}

	/** One permission scope or a list of permission scopes */
	@Input() scopes: ApplicationScopeTypes | ApplicationScopeTypes[] = null;

	/**
	 * Action to be performed if permission check has negative result
	 * (required for event emission)
	 */
	@Input() action: ScopeActionEnum = null;

	/**
	 * If `true`, prevents the CSS class `disabled` to be set on the host element.
	 */
	@Input() preventDisable = false;

	/**
	 * Emission event fired when permission check has negative result
	 * (requires `action` to be non-nullish)
	 */
	@Output() accessCheckResultEvent = new EventEmitter<string>();

	constructor(
		private _authorizationService: AuthorizationService,
		private _elementRef: ElementRef
	) { }

	ngOnInit() {
		if ( !this._authorizationService.hasAllPermissions( this.scopes, this.permissionCheck ) ) {
			this.setClass();
			if ( this.action ) { this.accessCheckResultEvent.emit( this.action ); }
		}
	}

	setClass() {
		switch ( this.action ) {
			case ScopeActionEnum.HIDE:
				this._elementRef.nativeElement.classList.add( 'd-none' );
				break;
			case ScopeActionEnum.DISABLE:
				if ( !this.preventDisable ) {
					this._elementRef.nativeElement.classList.add( 'disabled' );
				}
				break;
		}
	}
}
